const homeAf = {
  hero: {
    title: 'ګرامین بازار ته ښه راغلاست',
    subtitle: 'هغه څه ومومئ چې تاسو یې اړتیا لرئ',
  },
  search: {
    placeholderDefault: 'محصولات ولټوئ...',
    typewriterPlaceholders: ['چچکور بازار', 'عمومي پلورنځی', 'علیم پلورنځی', 'پالک'],
  },
  partners: {
    heading: 'زموږ شریکان',
    subheading: 'د باور وړ سازمانونو سره همکاري',
  },
};

export default homeAf;
